module.exports = __webpack_public_path__ + "f6be4113bec7a331413f6dc66a3109b4.svg";